import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProvisionOfUnpaidCare from './provision-of-unpaid-care';
import ProvisionOfUnpaidCareDetail from './provision-of-unpaid-care-detail';
import ProvisionOfUnpaidCareUpdate from './provision-of-unpaid-care-update';
import ProvisionOfUnpaidCareDeleteDialog from './provision-of-unpaid-care-delete-dialog';

const ProvisionOfUnpaidCareRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProvisionOfUnpaidCare />} />
    <Route path="new" element={<ProvisionOfUnpaidCareUpdate />} />
    <Route path=":id">
      <Route index element={<ProvisionOfUnpaidCareDetail />} />
      <Route path="edit" element={<ProvisionOfUnpaidCareUpdate />} />
      <Route path="delete" element={<ProvisionOfUnpaidCareDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProvisionOfUnpaidCareRoutes;
